var map = {
	"./C-primary.svg": 18922,
	"./M-primary.svg": 73450,
	"./P-primary.svg": 85027,
	"./R-primary.svg": 54990,
	"./S-primary.svg": 41934,
	"./T-primary.svg": 59177,
	"./U-primary.svg": 42410,
	"./V-primary.svg": 76664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47295;